var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"verifieed-step pad-side20"},[_c('TheVerifyTypeNew',{attrs:{"step":0}}),_c('TheVerifyIDCard',{on:{"confirm":_vm.confirm}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }